<button
  type="button"
  data-row-click-ignore
  [disabled]="!interactive()"
  [attr.aria-pressed]="interactive() ? (state() !== 'excluded') : null"
  [attr.aria-label]="tooltip()"
  [appTooltip]="tooltip()"
  position="top"
  (click)="onToggle()"
  class="relative inline-flex size-[30px] shrink-0 items-center justify-center rounded-lg text-xxs font-extrabold transition-opacity"
  [class.cursor-pointer]="interactive()"
  [class.cursor-default]="!interactive()"
  [class.opacity-60]="isMuted()"
  [class.opacity-55]="isExcluded()"
  [class.hover:opacity-100]="isExcluded()"
  [style.background-color]="isSolid() ? brandColour() : (isMuted() ? '' : 'transparent')"
  [style.color]="isSolid() ? '#ffffff' : (isMuted() ? 'var(--muted-foreground)' : brandColour())"
  [style.border-width]="isSolid() ? '0' : '1.5px'"
  [style.border-style]="state() === 'proposed' ? 'dashed' : 'solid'"
  [style.border-color]="isMuted() ? 'transparent' : brandColour()">
  {{ mark() }}

  @if (badge(); as badgeKind) {
    <span
      class="absolute -right-[3px] -bottom-[3px] inline-flex size-3.5 items-center justify-center rounded-full ring-[1.5px] ring-white dark:ring-zinc-900"
      [style.background-color]="badgeColour()">
      @switch (badgeKind) {
        @case ('check') {
          <svg viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="4"
               stroke-linecap="round" stroke-linejoin="round" class="size-2.5">
            <path d="M5 13l4 4L19 7" />
          </svg>
        }
        @case ('clock') {
          <svg viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3"
               stroke-linecap="round" stroke-linejoin="round" class="size-2.5">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        }
        @case ('slash') {
          <svg viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3"
               stroke-linecap="round" class="size-2.5">
            <circle cx="12" cy="12" r="9" />
            <path d="M8 8l8 8" />
          </svg>
        }
        @case ('warning') {
          <svg viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3"
               stroke-linecap="round" stroke-linejoin="round" class="size-2.5">
            <path d="M12 3l9 18H3L12 3z" />
            <path d="M12 10v5" />
            <path d="M12 18h.01" />
          </svg>
        }
        @case ('x') {
          <svg viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3"
               stroke-linecap="round" class="size-2.5">
            <path d="M6 6l12 12" />
            <path d="M18 6L6 18" />
          </svg>
        }
      }
    </span>
  }
</button>
